export enum PROJECT_STATUSES_ENUM {
    IN_PROGRESS = 'in_progress',
}

export const REFRESH_INTERVAL = 10000
export const PROJECT_LIST_LOAD_ITEMS = 10
export const PROJECT_HISTORY_LOAD_ITEMS = 25
